import type { HexColor } from '@getaccept/fried-tofu';
import * as ColorUtilsHelper from '../helpers/color-utils.helper';
import { t } from '../../helpers/translation.helper';
import { BackgroundType } from '../types/enums/background-type';
import { defaultFonts } from '../../fonts/default-fonts';
import { interV11 } from '../../fonts/font-faces';
import type { EntityTheme } from '../types/theme';

export class ThemeConstants {
  static fontFamily = () => interV11.fontFamily;
  static defaultFont = () => defaultFonts.find(f => f.fontFamily === this.fontFamily());

  static whiteButtonTextColor: HexColor = '#ffffff';
  static blackButtonTextColor: HexColor = '#000000';

  static defaultColor: HexColor = '#2c3b4e';
  static defaultButtonTextColor: HexColor = this.whiteButtonTextColor;
  static defaultH1Color: HexColor = '#2c3b4e';
  static defaultH2Color: HexColor = '#2c3b4e';
  static defaultTextColor: HexColor = '#2c3b4e';
  static defaultSupplementaryColor: HexColor = '#2c3b4e';

  static defaultBackgroundType = BackgroundType.GradientSolid;
  static defaultBackgroundGradientColorOne: HexColor = '#f8fafc';
  static defaultBackgroundGradientColorTwo = ColorUtilsHelper.calculateSecondaryColor(
    this.defaultBackgroundGradientColorOne
  );
  static defaultBackgroundGradientLightness = 0;

  static defaultTheme = (): Omit<EntityTheme, 'id'> => ({
    name: t('new-theme'),
    backgroundImage: '',
    color: this.defaultColor,
    buttonTextColor: this.defaultButtonTextColor,
    h1Color: this.defaultH1Color,
    h2Color: this.defaultH2Color,
    textColor: this.defaultTextColor,
    supplementaryColor: this.defaultSupplementaryColor,
    backgroundGradientColorOne: this.defaultBackgroundGradientColorOne,
    backgroundGradientColorTwo: this.defaultBackgroundGradientColorTwo,
    backgroundType: this.defaultBackgroundType,
    backgroundGradientLightness: this.defaultBackgroundGradientLightness,
    fontSettings: {
      defaultFont: this.defaultFont(),
      headingsFont: this.defaultFont(),
    },
  });
}
